import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { get, post } from '../../util/request'
import { format } from 'date-fns'
import { FileUploader } from '../../components/FileUploader'
import { logout } from '../../redux/action/auth.action'

const Checkbox = ({ label, value, isSelected, onCheckboxChange, deleteChecklist, id, nameId, modal }) => {
  return (
    <div className='flex justify-between'>
      <div className="flex gap-2">
        <input
          type="checkbox"
          value={value}
          checked={isSelected}
          onChange={(e) => onCheckboxChange(e, nameId, id, isSelected, modal)}
          className="relative w-4 h-4 mt-1 bg-white border-2 rounded-sm appearance-none peer shrink-0 checked:bg-white checked:border-0"
        />
        <label className='text-sm' >{label}</label>
        {isSelected === 1 ? <svg
          className="absolute block w-4 h-4 mt-1 pointer-events-none"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="#22c55e"
        >
          <path fillRule="evenodd" d="M4.5 7.5a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9Z" clipRule="evenodd" />
        </svg> : ''}


      </div>
      <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/trash.svg"} className='justify-end w-6 py-1' onClick={() => deleteChecklist(true, nameId, id, label, modal)} />

    </div>
  );
};

const DetailTugas = () => {
  const { detail } = useParams()
  const { id } = useParams()
  const [state, setState] = useState({
    tasksDetail: '',
    details: '',
    feedbacks: '',
    loading: true,
    selectedDetails: '',
    selectedFeedback: '',
    addChecklist: '',
    showModalAddChecklist: false,
    showModalDeleteChecklist: false,
    showModalDeleteFile: false,
    showModalSuccess: false,
    showFailedAddModal: false,
    done: false,
    checklistDesc: '',
    modal: '',
    checklistDelete: '',
    idFile: '',
    taskStatus: ''

  })

  const jwtToken = useSelector(state => state.auth.generateToken)
  const user = useSelector(state => state.auth.user)
  const dispatch = useDispatch()
  const navigate = useNavigate()


  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      var url = `public/api/v2/task-detail?company_task_id=${detail}&employee_id=${user.employee_id}`

      getTasksList(url)

    }
    return () => isMounted === false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const getTasksList = (url) => {
    get(
      url,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      success => {
        setState(prevState => {
          return {
            ...prevState,
            tasksDetail: success.data.Data,
            details: success.data.Data.details,
            feedbacks: success.data.Data.feedbacks,
            taskStatus: success.data.Data.status.report_status_id,
            loading: false
          }
        })
      },
      error => {

        if (error.status === 401) {
          dispatch(logout())
        }
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  const formatDate = (date, time) => {
    const dt1 = new Date(date);
    var d1 = format(dt1, 'EEEE, dd MMMM yyyy')
    let hour = time.slice(0, 5);
    return d1 + " " + hour
  }

  const formatDate2 = (date) => {
    var d1 = format(date, 'HH:mm - dd MMMM yyyy')
    return d1
  }

  const handleModal = (modal, name) => {
    setState({
      ...state,
      showModalAddChecklist: modal,
      modal: name,
      checklistDesc: '',
    })
  }

  const handleModalDelete = (modal, nameid, id, label, name) => {
    setState({
      ...state,
      showModalDeleteChecklist: modal,
      checklistDelete: {
        [nameid]: id
      },
      modal: name,
      checklistDesc: label
    })
  }

  const handleValueChange = (e) => {
    setState({
      ...state,
      checklistDesc: e.target.value,
    })
  }

  const handleAddCheckList = () => {
    const data = {
      company_task_id: detail,
      description: state.checklistDesc
    }

    if (state.modal === 'Detail') {
      post(
        `public/api/v2/task-add-checklist`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Content-Type': 'application/json'
          },
        },
        data,
        success => {
          setState({
            ...state,
            showModalAddChecklist: false
          })
        },
        error => {
          if (error.status === 403) {
            setState({
              ...state,
              showFailedAddModal: true,
              showModalAddChecklist: false

            })
          }
          setState(prevState => {
            return {
              ...prevState,
              loading: false
            }
          })
          console.log('error request', error)
        }
      )
    }

    if (state.modal === 'Feedback') {
      post(
        `public/api/v2/task-add-feedback`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Content-Type': 'application/json'
          },
        },
        data,
        success => {
          setState({
            ...state,
            showModalAddChecklist: false
          })
        },
        error => {
          if (error.status === 403) {
            setState({
              ...state,
              showFailedAddModal: true,
              showModalAddChecklist: false

            })
          }
          setState(prevState => {
            return {
              ...prevState,
              loading: false
            }
          })
          console.log('error request', error)
        }
      )
    }

  }


  const handleDeleteCheckList = (data) => {

    if (state.modal === 'Detail') {
      post(
        `public/api/v2/task-delete-checklist`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Content-Type': 'application/json'
          },
        },
        data,
        success => {
          setState({
            ...state,
            showModalDeleteChecklist: false
          })
        },
        error => {
          setState(prevState => {
            return {
              ...prevState,
              loading: false
            }
          })
          console.log('error request', error)
        }
      )
    }

    if (state.modal === 'Feedback') {
      post(
        `public/api/v2/task-delete-feedback`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Content-Type': 'application/json'
          },
        },
        data,
        success => {
          setState({
            ...state,
            showModalDeleteChecklist: false
          })
        },
        error => {
          setState(prevState => {
            return {
              ...prevState,
              loading: false
            }
          })
          console.log('error request', error)
        }
      )
    }

  }


  const handleCheckboxChange = (event, nameid, id, status, modal) => {

    const data = {
      [nameid]: id,
      status: status === 1 ? 0 : 1
    }


    if (modal === 'Detail') {
      post(
        `public/api/v2/task-update-checklist`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Content-Type': 'application/json'
          },
        },
        data,
        success => {
          setState({
            ...state,
            loading: false
            // showModalDeleteChecklist: false
          })
          window.location.reload();
        },
        error => {
          setState(prevState => {
            return {
              ...prevState,
              loading: false
            }
          })
          console.log('error request', error)
        }
      )
    }

    if (modal === 'Feedback') {
      post(
        `public/api/v2/task-update-feedback`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Content-Type': 'application/json'
          },
        },
        data,
        success => {
          setState({
            ...state,
            loading: false
            // showModalDeleteChecklist: false
          })
          window.location.reload();

        },
        error => {
          setState(prevState => {
            return {
              ...prevState,
              loading: false
            }
          })
          console.log('error request', error)
        }
      )
    }

  };


  const handleFile = (file) => {
    const formData = new FormData();
    formData.append("file", file);

    post(
      `public/api/v2/task-add-file?company_task_id=${detail}&employee_id=${user.employee_id}`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'multipart/form-data'
        },
      },
      {
        company_task_id: detail,
        file: file
      },
      success => {
        // setShowModal(false)
        window.location.reload();

      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )

  };

  const handleDeleteFileModal = (modal, name, id) => {
    setState({
      ...state,
      showModalDeleteFile: modal,
      modal: name,
      idFile: id,
    })
  }


  const handleDeleteFile = (id) => {

    post(
      `public/api/v2/task-delete-file`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'multipart/form-data'
        },
      },
      {
        id: id
      },
      success => {
        // setShowModal(false)
        window.location.reload();

      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )

  };

  const handleSelectedStatus = (e) => {
    setState({
      ...state,
      taskStatus: e.target.value
    })
  }

  const handleFailedAddModal = (e) => {
    setState({
      ...state,
      showFailedAddModal: e
    })
  }

  const handleUpdateTask = (modal, done) => {
    setState({
      ...state,
      showModalSuccess: modal,
      done: done
    })

    if (done) {
      post(
        `public/api/v2/task-update?company_task_id=${detail}&employee_id=${user.employee_id}`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Content-Type': 'multipart/form-data'
          },
        },
        {
          company_task_id: detail,
          status: state.taskStatus
        },
        success => {
          // setShowModal(false)
          // window.location.reload();

        },
        error => {
          setState(prevState => {
            return {
              ...prevState,
              loading: false
            }
          })
          console.log('error request', error)
        }
      )
    }



  };

  const handleCloseModal = (modal, done) => {

    setState({
      ...state,
      showModalSuccess: modal,
      done: done
    })
    navigate("/tugas-kerja/" + id);

    // post(
    //   `public/api/v2/task-update?company_task_id=${detail}&employee_id=${user.employee_id}`,
    //   {
    //     headers: {
    //       Authorization: `Bearer ${jwtToken}`,
    //       'Content-Type': 'multipart/form-data'
    //     },
    //   },
    //   {
    //     company_task_id: detail,
    //     status: state.taskStatus
    //   },
    //   success => {
    //     // setShowModal(false)
    //     // window.location.reload();

    //   },
    //   error => {
    //     setState(prevState => {
    //       return {
    //         ...prevState,
    //         loading: false
    //       }
    //     })
    //     console.log('error request', error)
    //   }
    // )

  };


  return (
    state.loading ? '' :
      <div className='w-full h-screen grid-cols-1 bg-white sm:grid-cols-2'>
        <div className='w-full h-20 bg-real-white'>
          <div className='flex items-center h-full px-4'>
            <a href={process.env.PUBLIC_URL + "/tugas-kerja/" + id}>
              <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
            </a>
            <p className='px-4'>Detail Tugas</p>
          </div>
        </div>

        <div className='w-full h-screen bg-real-white'>
          <div className='grid grid-cols-1'>
            <div className="p-4 mx-4 rounded-lg bg-real-white">
              <p className='col-span-3 py-1 text-base font-bold'>{state.tasksDetail.task_title}</p>
              <div className='flex items-center'>
                <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/calendar-red.svg"} className='justify-start w-6 pr-1' style={{ color: state.tasksDetail.is_overdue_color }} />
                <p className='w-4/5 col-span-3 py-1 text-base font-bold'>{formatDate(state.tasksDetail.end_date, state.tasksDetail.end_time)}</p>
                <span className="inline-flex items-center px-3 py-1 text-xs font-medium text-white rounded-md ring-1 ring-inset ring-gray-500/10" style={{ backgroundColor: state.tasksDetail.is_overdue_color }}>{state.tasksDetail.status_text}</span>
              </div>
              <p className='w-full col-span-3 py-1 text-base font-bold'>Deskripsi</p>
              <p className='w-full col-span-3 py-1'>{state.tasksDetail.task_description}</p>

              <p className='w-full col-span-3 py-1 text-base font-bold'>Details</p>
              <p className='w-full col-span-3 py-1 text-base font-bold text-center'>50%</p>
              <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                <div className="bg-green-500 h-2.5 rounded-full" style={{ width: "50%" }}></div>
              </div>

              <div className='w-full py-8'>
                {state.tasksDetail?.details?.map((item, index) => (
                  <Checkbox
                    label={item.description}
                    value={item.cptd_id}
                    name={'selectedDetails'}
                    isSelected={item.status}
                    onCheckboxChange={handleCheckboxChange}
                    deleteChecklist={handleModalDelete}
                    nameId={'cptd_id'}
                    modal={'Detail'}
                    key={index}
                    id={item.cptd_id} />

                ))}

                <div className='py-4 border-b border-gray-500 cursor-pointer' onClick={() => handleModal(true, 'Detail')}>+ Add an Item</div>
              </div>


              <p className='w-full col-span-3 py-1 text-base font-bold'>Feedbacks</p>
              <p className='w-full col-span-3 py-1 text-base font-bold text-center'>50%</p>
              <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                <div className="bg-green-500 h-2.5 rounded-full" style={{ width: "50%" }}></div>
              </div>

              <div className='w-full py-8'>
                {state.feedbacks?.map((item, index) => (
                  <Checkbox
                    label={item.description}
                    value={item.cptf_id}
                    name={'selectedFeedback'}
                    isSelected={item.status}
                    onCheckboxChange={handleCheckboxChange}
                    deleteChecklist={handleModalDelete}
                    nameId={'cptf_id'}
                    modal={'Feedback'}
                    key={index}
                    id={item.cptf_id} />

                ))}

                <div className='py-4 border-b border-gray-500 cursor-pointer' onClick={() => handleModal(true, 'Feedback')}>+ Add an Item</div>
              </div>

              <div className='w-full py-8'>
                <div className='flex justify-start gap-2'>
                  <div className="w-8 h-8 py-2 text-xs font-medium text-center text-black border border-blue-600 rounded-full">UL</div>
                  <div className="w-8 h-8 py-2 text-xs font-medium text-center text-black border border-blue-600 rounded-full">WD</div>
                </div>
                <p className='w-full col-span-3 py-1 text-base font-bold'>File</p>
                {state.tasksDetail.files.map((item, index) => (
                  <div className='flex justify-between'>
                    <a href={item.file_url}>File {index + 1}</a>
                    <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/trash.svg"} className='justify-end w-6 py-1' onClick={() => handleDeleteFileModal(true, `File ${index + 1}`, item.cptfl_id)} />
                    {/* <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/trash.svg"} className='justify-end w-6 py-1' onClick={() => deleteChecklist(true, nameId, id, label, modal)} /> */}
                  </div>
                ))}
                <FileUploader handleFile={handleFile} />
                {/* {fileName ? <p>Uploaded file: {fileName}</p> : null} */}

                {/* <button className='px-4 py-2 mt-4 bg-gray-100 rounded-full'>+ Lampiran Tugas</button> */}
                <div className='w-full h-full py-4'>
                  <select id="countries" value={state.taskStatus} onChange={(e) => handleSelectedStatus(e)} className="block w-full p-4 text-sm text-gray-900 bg-gray-100 border rounded-lg border-bg-primary focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    <option value={1}>TODO</option>
                    <option value={2}>IN PROGRESS</option>
                    <option value={3}>IN REVIEW</option>
                    <option value={4}>DONE</option>
                    <option value={5}>FEEDBACK</option>
                    <option value={6}>RESOURCE</option>
                    <option value={7}>BACK LOG</option>
                  </select>
                </div>

                <div className='w-full h-full py-4'>
                  <div onClick={(e) => handleUpdateTask(true, true)} className="block px-8 rounded-full bg-gradient-to-b from-red-light-bg to-orange-bg hover:bg-gradient-to-b hover:from-red-dark-bg hover:to-orange-dark-bg py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                    SELESAI
                  </div>
                </div>

                <div className='w-full h-full py-4'>
                  <div onClick={(e) => handleUpdateTask(true, false)} className="block px-8 rounded-full border border-black hover:bg-gradient-to-b hover:from-red-dark-bg hover:to-orange-dark-bg py-2.5 text-center text-sm font-semibold text-black shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                    BELUM SELESAI
                  </div>
                </div>
              </div>
            </div>
          </div>
          {state.showModalAddChecklist ? (
            <>
              <div
                className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
              >
                <div className="relative w-3/4 max-w-3xl mx-auto my-6">
                  {/*content*/}
                  <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
                    <div className="flex items-start justify-between p-5 border-b border-solid rounded-t border-blueGray-200">
                      <h3 className="text-3xl font-semibold">
                        Add Checklist {state.modal}
                      </h3>
                      <button
                        className="float-right p-1 ml-auto text-3xl font-semibold leading-none text-black bg-transparent border-0 outline-none opacity-5 focus:outline-none"
                        onClick={() => handleModal(false, state.modal)}
                      >
                        <span className="block w-6 h-6 text-2xl text-black bg-transparent outline-none opacity-5 focus:outline-none">
                          ×
                        </span>
                      </button>
                    </div>
                    {/*body*/}
                    <div className="relative flex-auto p-6">
                      <div className='w-full px-4 py-2'>
                        <div className="mt-2.5">
                          <input
                            type="text"
                            name="employee_nik"
                            id="employee_nik"
                            placeholder='Checklist'
                            value={state.checklistDesc}
                            onChange={(e) => handleValueChange(e)}
                            className="block w-full rounded-md border-0 px-3.5 py-4 bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                          />
                        </div>

                      </div>
                    </div>
                    {/*footer*/}
                    <div className="flex items-center justify-end p-6 border-t border-solid rounded-b border-blueGray-200">
                      <button
                        className="px-6 py-2 mb-1 mr-1 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear rounded outline-none bg-red-bg text-grey-500 background-transparent focus:outline-none"
                        type="button"
                        onClick={() => handleAddCheckList(state.modal)}
                      >
                        Save
                      </button>

                      <button
                        className="px-6 py-2 mb-1 mr-1 text-sm font-bold uppercase transition-all duration-150 ease-linear outline-none text-grey-500 background-transparent focus:outline-none"
                        type="button"
                        onClick={() => handleModal(false, state.modal)}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
            </>
          ) : null}

          {state.showModalDeleteChecklist ? (
            <>
              <div
                className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
              >
                <div className="relative w-3/4 max-w-3xl mx-auto my-6">
                  {/*content*/}
                  <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">

                    {/*body*/}
                    <div className="relative flex-auto p-6">
                      <div>
                        <p className='pt-4 pb-2 font-bold'> Delete Checklist {state.modal} </p>
                        <p className=''>{state.checklistDesc}</p>
                      </div>
                    </div>
                    {/*footer*/}
                    <div className="flex items-center justify-end p-6 border-t border-solid rounded-b border-blueGray-200">
                      <button
                        className="px-6 py-2 mb-1 mr-1 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear rounded outline-none bg-red-bg text-grey-500 background-transparent focus:outline-none"
                        type="button"
                        onClick={() => handleDeleteCheckList(state.checklistDelete)}
                      >
                        Delete
                      </button>

                      <button
                        className="px-6 py-2 mb-1 mr-1 text-sm font-bold uppercase transition-all duration-150 ease-linear outline-none text-grey-500 background-transparent focus:outline-none"
                        type="button"
                        onClick={() => handleModalDelete(false, '', '', '')}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
            </>
          ) : null}

          {state.showModalDeleteFile ? (
            <>
              <div
                className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
              >
                <div className="relative w-3/4 max-w-3xl mx-auto my-6">
                  {/*content*/}
                  <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">

                    {/*body*/}
                    <div className="relative flex-auto p-6">
                      <div>
                        <p className='pt-4 pb-2 font-bold'> Delete file {state.modal} ?</p>
                        {/* <p className=''>{state.checklistDesc}</p> */}
                      </div>
                    </div>
                    {/*footer*/}
                    <div className="flex items-center justify-end p-6 border-t border-solid rounded-b border-blueGray-200">
                      <button
                        className="px-6 py-2 mb-1 mr-1 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear rounded outline-none bg-red-bg text-grey-500 background-transparent focus:outline-none"
                        type="button"
                        onClick={() => handleDeleteFile(state.idFile)}
                      >
                        Delete
                      </button>

                      <button
                        className="px-6 py-2 mb-1 mr-1 text-sm font-bold uppercase transition-all duration-150 ease-linear outline-none text-grey-500 background-transparent focus:outline-none"
                        type="button"
                        onClick={() => handleDeleteFileModal(false, '', '')}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
            </>
          ) : null}

          {state.showFailedAddModal ? (
            <>
              <div
                className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
              >
                <div className="relative w-3/4 max-w-3xl mx-auto my-6">
                  {/*content*/}
                  <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">

                    {/*body*/}
                    <div className="relative flex-auto p-6">
                      <div>
                        <p className='pt-4 pb-2 text-center'> Tidak ada akses untuk menambah checklist atau feedback</p>
                        {/* <p className=''>{state.checklistDesc}</p> */}
                      </div>
                    </div>
                    {/*footer*/}
                    <div className="flex items-center justify-end p-6 border-t border-solid rounded-b border-blueGray-200">

                      <button
                        className="px-6 py-2 mb-1 mr-1 text-sm font-bold uppercase transition-all duration-150 ease-linear outline-none text-grey-500 background-transparent focus:outline-none"
                        type="button"
                        onClick={() => handleFailedAddModal(false)}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
            </>
          ) : null}

          {state.showModalSuccess ? (
            <>
              <div
                className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
              >
                <div className="relative w-3/4 max-w-3xl mx-auto my-6">
                  {/*content*/}
                  <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none bg-gradient-to-b from-red-light-bg to-orange-bg ">

                    {/*body*/}
                    <div className="relative flex-auto p-6">
                      {state.done ? (
                        <div className='mx-auto text-center'>
                          {/* <p className=''>{state.checklistDesc}</p> */}
                          <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/yes.png"} className='w-40 py-1 mx-auto' />
                          <p className='py-2 font-bold text-white'>Selamat tugas kamu hari ini sudah selesai!</p>
                          <p className='py-2 font-semibold text-white'>{state.tasksDetail.task_title}</p>
                          <p className='py-2 font-semibold text-white'>{formatDate2(new Date())}</p>
                          <button
                            className="px-6 py-2 mb-1 mr-1 text-sm font-bold uppercase transition-all duration-150 ease-linear outline-none rounded-xl text-red-bg bg-real-white text-grey-500 background-transparent focus:outline-none"
                            type="button"
                            onClick={() => handleCloseModal(false, false)}
                          >
                            Simpan
                          </button>
                        </div>
                      ) :
                        <div className='mx-auto text-center'>
                          {/* <p className=''>{state.checklistDesc}</p> */}
                          <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/sorry.png"} className='w-40 py-1 mx-auto' />
                          <p className='py-2 font-bold text-white'>Maaf tugas kamu hari ini belum diselesaikan</p>
                          <p className='py-2 font-semibold text-white'>Mohon segera diselesaikan</p>
                          <button
                            className="px-6 py-2 mb-1 mr-1 text-sm font-bold uppercase transition-all duration-150 ease-linear outline-none rounded-xl text-red-bg bg-real-white text-grey-500 background-transparent focus:outline-none"
                            type="button"
                            onClick={() => handleCloseModal(false, false)}
                          >
                            Simpan
                          </button>
                        </div>}

                    </div>
                    {/*footer*/}
                  </div>
                </div>
              </div>
              <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
            </>
          ) : null}
        </div>
      </div >

  )
}

export default DetailTugas